import {FC, useState, useEffect} from 'react'
import {PageTitle} from '../../../../_metronic/layout/core'
import {Card, Row, Col, Image} from 'react-bootstrap'
import {Link} from 'react-router-dom'
import {useAbility} from '@casl/react'
import {AbilityContext} from '../../../modules/auth/core/AbilityContext'
import useAxiosPrivate from '../../../libs/useAxiosPrivate'
import {CoefIoLm} from './core/_models'
import {getAllCoefIoLm} from './core/_requests'
import {ListCoefIoLmTable} from './components/ListCoefIoLmTable'

const CoefIoLmPage: FC<{subject: string}> = ({subject}) => {
  const ability = useAbility(AbilityContext)
  const axiosPrivate = useAxiosPrivate()
  const [isLoading, setIsLoading] = useState(true)
  const [listCoefIoLm, setListCoefIoLm] = useState<CoefIoLm[] | null>([])

  const fetchCoefIoLm = () => {
    setIsLoading(true)
    getAllCoefIoLm(axiosPrivate)
      .then((res) => {
        setListCoefIoLm(res.data.table_data)
      })
      .catch((e) => {
        console.error('Failed to fetch Coef IO LM:', e)
      })
      .finally(() => {
        setIsLoading(false)
      })
  }

  useEffect(() => {
    fetchCoefIoLm()
  }, [])

  return (
    <>
      <PageTitle
        breadcrumbs={[
          {title: 'Home', path: '/', isSeparator: false, isActive: false},
          {title: '', path: '', isSeparator: true, isActive: false},
        ]}
      >
        Coefficient Input Output LM
      </PageTitle>

      <div className='CoefIoLmPage'>
        <Row className='mb-5'>
          <Col>
            <Card className='card-custom card-border'>
              <Card.Body className='d-flex align-items-center'>
                <Image src='/media/tina/img-result-documents.jpg' thumbnail width={110} />
                <div className='ms-5 d-flex flex-column justify-content-center'>
                  <h3 className='text-primary'>Coefficient Input Output LM</h3>
                  <div className='text-gray-700'>
                    In this module, you can manage Coefficient Input Output LM records.
                  </div>
                </div>
              </Card.Body>
            </Card>
          </Col>
        </Row>

        <Row className='mb-5'>
          <Col>
            <Card>
              <Card.Header className='card-header-stretch'>
                <Card.Title className='w-100'>
                  <div className='title-container w-100 d-flex justify-content-between align-items-center'>
                    <div className='title d-flex align-items-center'>
                      <span className='fa fa-table px-2'></span>
                      <h3 className='text-gray-700'>List Coefficient Input Output LM</h3>
                    </div>
                    {ability.can('create', subject) ? (
                      <div className='card-action'>
                        <Link
                          to={'/coef-io-lm/add'}
                          className='btn btn-primary d-flex gap-4 align-items-center'
                        >
                          <span className='fa fa-plus'></span>
                          Add
                        </Link>
                      </div>
                    ) : (
                      ''
                    )}
                  </div>
                </Card.Title>
              </Card.Header>
              <Card.Body>
                <ListCoefIoLmTable
                  subject={subject}
                  onCoefIoLmDelete={(deletedId) => {
                    setListCoefIoLm((prev) =>
                      prev ? prev.filter((item) => item.id !== deletedId) : null
                    )
                  }}
                  rows={listCoefIoLm}
                  isLoading={isLoading}
                />
              </Card.Body>
            </Card>
          </Col>
        </Row>
      </div>
    </>
  )
}

export default CoefIoLmPage
